// extracted by mini-css-extract-plugin
export default {"icon":"rVONKg","text":"c6RWXr","button":"pSBF6v"};